import { StarIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Toggle } from '@/components/ui/toggle';
import { ALL_RATINGS } from '@/modules/analytics/utils/expandRatings';

const STAR_ICON = <StarIcon size={16} />;

type CsatStarTogglesProps = {
  selected: number[];
  onToggle: (star: number) => void;
  isDisabled?: (star: number) => boolean;
};

export const CsatStarToggles = ({ selected, onToggle, isDisabled }: CsatStarTogglesProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap justify-between gap-1" role="group">
      {ALL_RATINGS.map((star) => (
        <Toggle
          key={star}
          pressed={selected.includes(star)}
          onPressedChange={() => onToggle(star)}
          disabled={isDisabled?.(star)}
          aria-label={t('analytics.star', { count: star })}
          className="h-10 w-15.5"
          variant="outline"
        >
          <span className="flex items-center gap-1">
            {STAR_ICON}
            <span className="text-sm font-medium">{star}</span>
          </span>
        </Toggle>
      ))}
    </div>
  );
};
